<template>
  <b-card-code title="Perubahan Nilai">

    <!-- Tabs with card integration -->
    <b-tabs
      v-model="tabIndex"
    >
      <b-tab title="Dosen Pembimbing">
        <div class="mt-5 mb-5">
          <div class="mb-3" v-for="item in mainData.nilai_pembimbing" :key="item.id">
            <div class="d-flex">
              <h5 class="mb-3 mr-3">{{item.group}}</h5>
              <h5>Nilai Rata-Rata : {{item.nilai_rata_rata}}</h5>
            </div>
              <b-row v-for="pertanyaan in item.pertanyaan" :key="pertanyaan.id">
                <b-col cols="6">
                    <b-form-group
                      :label="pertanyaan.pertanyaan"
                      :label-for="pertanyaan.pertanyaan"
                    >
                      <b-form-input
                        :id="'p'+pertanyaan.id"
                        placeholder="Masukkan Nilai"
                        type="number"
                        v-model="pertanyaan.jawaban"
                      /> 
                    </b-form-group>
                  </b-col>
              </b-row>
          </div>
          <b-row class="mt-2">
            <b-form-group>
              <label for=""  class="ml-1">Apakah perubahan nilai sidah disetujui oleh pembimbing atau penguji? <span style="color: red; font-size: 16px;">*</span></label>
              <v-select
              class="ml-1"
                id="perubahan_nilai"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="title"
                :reduce="val => val.value"
                :options="persetujuanPerubahanOption.options"
                v-model="mainData.persetujuan_perubahan_pembimbing"
                placeholder="Pilih Perubahan Nilai"
              />
            </b-form-group>
            </b-row>
            <b-row class="mt-2">
              <b-col cols="12">
                <div class="d-flex justify-content-end">
                  <b-spinner
                    style="margin-right: 10px; margin-top:17px;"
                    :variant="'dark'"
                    v-if="showLoading == 1 && stopLoading == 0"
                  ></b-spinner>
                  <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                  class="mt-1 mr-1"
                  @click="simpanDataJawaban('pembimbing')"
                >
                  Simpan
                </b-button>
                </div>
              </b-col>
          </b-row>
        </div>
      </b-tab>
      <b-tab title="Dosen Penguji Utama">
        <div class="mt-5 mb-5">
          <div class="mb-3" v-for="item in mainData.nilai_penguji_utama" :key="item.id">
            <div class="d-flex">
              <h5 class="mb-3 mr-3">{{item.group}}</h5>
              <h5>Nilai Rata-Rata : {{item.nilai_rata_rata}}</h5>
            </div>
              <b-row v-for="pertanyaan in item.pertanyaan" :key="pertanyaan.id">
                <b-col cols="6">
                    <b-form-group
                      :label="pertanyaan.pertanyaan"
                      :label-for="pertanyaan.pertanyaan"
                    >
                      <b-form-input
                        :id="'p'+pertanyaan.id"
                        placeholder="Masukkan Nilai"
                        type="number"
                        v-model="pertanyaan.jawaban"
                      /> 
                    </b-form-group>
                  </b-col>
              </b-row>
          </div>
          <b-row class="mt-2">
            <b-form-group>
              <label for=""  class="ml-1">Apakah perubahan nilai sidah disetujui oleh pembimbing atau penguji? <span style="color: red; font-size: 16px;">*</span></label>
              <v-select
              class="ml-1"
                id="perubahan_nilai"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="title"
                :reduce="val => val.value"
                :options="persetujuanPerubahanOption.options"
                v-model="mainData.persetujuan_perubahan_penguji_utama"
                placeholder="Pilih Perubahan Nilai"
              />
            </b-form-group>
            </b-row>
            <b-row class="mt-2">
              <b-col cols="12">
                <div class="d-flex justify-content-end">
                  <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                  class="mt-1 mr-1"
                  @click="simpanDataJawaban('penguji_utama')"
                >
                  Simpan
                </b-button>
                </div>
              </b-col>
          </b-row>
        </div>
      </b-tab>
      <b-tab title="Dosen Penguji 2">
        <div class="mt-5 mb-5">
          <div class="mb-3" v-for="item in mainData.nilai_penguji" :key="item.id">
            <div class="d-flex">
              <h5 class="mb-3 mr-3">{{item.group}}</h5>
              <h5>Nilai Rata-Rata : {{item.nilai_rata_rata}}</h5>
            </div>
              <b-row v-for="pertanyaan in item.pertanyaan" :key="pertanyaan.id">
                <b-col cols="6">
                    <b-form-group
                      :label="pertanyaan.pertanyaan"
                      :label-for="pertanyaan.pertanyaan"
                    >
                      <b-form-input
                        :id="'p'+pertanyaan.id"
                        placeholder="Masukkan Nilai"
                        type="number"
                        v-model="pertanyaan.jawaban"
                      /> 
                    </b-form-group>
                  </b-col>
              </b-row>
          </div>
          <b-row class="mt-2">
            <b-form-group>
              <label for=""  class="ml-1">Apakah perubahan nilai sidah disetujui oleh pembimbing atau penguji? <span style="color: red; font-size: 16px;">*</span></label>
              <v-select
              class="ml-1"
                id="perubahan_nilai"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="title"
                :reduce="val => val.value"
                :options="persetujuanPerubahanOption.options"
                v-model="mainData.persetujuan_perubahan_penguji"
                placeholder="Pilih Perubahan Nilai"
              />
            </b-form-group>
            </b-row>
            <b-row class="mt-2">
              <b-col cols="12">
                <div class="d-flex justify-content-end">
                  <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                  class="mt-1 mr-1"
                  @click="simpanDataJawaban('penguji')"
                >
                  Simpan
                </b-button>
                </div>
              </b-col>
          </b-row>
        </div>
      </b-tab>
    </b-tabs>

    <!-- Control buttons-->
    <div class="text-center">
      <b-button-group class="mt-1">
        <b-button
          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
          variant="outline-primary"
          @click="tabIndex--"
        >
          Kembali
        </b-button>
        <b-button
          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
          variant="outline-primary"
          @click="tabIndex++"
        >
          Lanjut
        </b-button>
      </b-button-group>

      <b-card-text>
        <small>Tab Aktif: {{ tabIndex }}</small>
      </b-card-text>
    </div>

    <!-- <template #code>
      {{ codeProgrammatically }}
    </template> -->
  </b-card-code>
</template>

<script>
import BCardCode from '@core/components/b-card-code'
import {
  BButtonGroup, BButton, BCard, BTab, BTabs, BCardText, BCol, BRow, BFormGroup, BFormInput, BSpinner,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import {
  getDetailPerubahanNilaiHasilSidang,
  updatePerubahanNilai,
} from '@/connection-api/master'
import vSelect from 'vue-select'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
// import { codeProgrammatically } from './code'

export default {
  components: {
    BCardCode,
    BButtonGroup,
    BButton,
    BCard,
    BTab,
    BTabs,
    BCardText,
    BCol,
    BRow,
    BFormGroup,
    BFormInput,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    BSpinner,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      showLoading: 0,
      stopLoading: 1,
      tabIndex: 0,
      mainData: {},
      // codeProgrammatically,
      persetujuanPerubahanOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Persetujuan --' },
          { value: 'ya', title: 'Ya' },
          { value: 'tidak', title: 'Tidak' },
        ],
      },
    }
  },
  mounted() {
    getDetailPerubahanNilaiHasilSidang(this.$route.params.uuid)
      .then(response => {
        if (response.data.success === true) {
          this.mainData = response.data.data
        }
      })
      .catch(error => console.log(error));
  },
  methods: {
    reloadData(){
      getDetailPerubahanNilaiHasilSidang(this.$route.params.uuid)
      .then(response => {
        if (response.data.success === true) {
          this.mainData = response.data.data
        }
      })
      .catch(error => console.log(error));
    },
    simpanDataJawaban(params){
      if(params == 'pembimbing')
      {
        this.mainData.flag = params
        updatePerubahanNilai(this.mainData)
        .then(response => {
          if (response.data.success == true) {
            this.showLoading = 0
            this.stopLoading = 1
            this.mainData = response.data.data
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Perubahan Nilai',
                icon: 'EditIcon',
                variant: 'success',
                text: response.data.message,
              },
            })
            this.reloadData()
            resolve(true)
          } else {
            reject()
            
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Perubahan Nilai',
                icon: 'EditIcon',
                variant: 'danger',
                text: response.data.message,
              },
            })
            
          }
        })
        .catch(error => console.log(error));
      }

      if(params == 'penguji_utama')
      {
        this.mainData.flag = params
        updatePerubahanNilai(this.mainData)
        .then(response => {
          if (response.data.success == true) {
            this.showLoading = 0
            this.stopLoading = 1
            this.reloadData()
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Perubahan Nilai',
                icon: 'EditIcon',
                variant: 'success',
                text: response.data.message,
              },
            })
            resolve(true)
          } else {
            reject()
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Perubahan Nilai',
                icon: 'EditIcon',
                variant: 'danger',
                text: response.data.message,
              },
            })
            
          }
        })
        .catch(error => console.log(error));
      }

      if(params == 'penguji')
      {
        this.showLoading = 0
        this.stopLoading = 1
        this.mainData.flag = params
        updatePerubahanNilai(this.mainData)
        .then(response => {
          if (response.data.success == true) {
            
            // this.mainData = response.data.data
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Perubahan Nilai',
                icon: 'EditIcon',
                variant: 'success',
                text: response.data.message,
              },
            })
            this.reloadData()
            resolve(true)
          } else {
            reject()
            
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Perubahan Nilai',
                icon: 'EditIcon',
                variant: 'danger',
                text: response.data.message,
              },
            })
          }
        })
        .catch(error => console.log(error));
      }
    }
  },
}
</script>
